export default "__VITE_ASSET__BxVHmWWP__"